import * as React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/reducer';
import usePaginationHook from '../../common/hook/usePaginationHook';
import { API_SERVER } from '../../common/api';
import { formatDateFilterField } from '../../common/utils';
import { Paper, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import FilterDentalBox from 'modules/reception/component/dental/FilterDentalBox';
import DentalList from '../dental/DentalList';
import { useFetch } from 'modules/common/hook';

interface Props {}

const NurseDentalListPage: React.FunctionComponent<Props> = () => {
  const orderTherapy = useSelector((appState: AppState) => appState.common.orderTherapy);
  const hookPagination = usePaginationHook({
    defaultFilter: {
      orderBy: orderTherapy,
    },
  });
  const { params } = hookPagination;

  const { data, revalidate, isValidating } = useFetch(
    API_SERVER.dentalExam.getList(formatDateFilterField(params, 'fromDate', 'toDate')),
    { revalidateOnMount: true, revalidateOnFocus: false },
  );

  return (
    <>
      <Paper elevation={1} style={{ padding: 16, flex: 1, overflow: 'hidden' }}>
        <FilterDentalBox
          hookPagination={hookPagination}
          onRegister={() => {}}
          pagin={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navMenu.encounterList.dental" />
              </Typography>
              <Typography variant="caption">
                <FormattedMessage
                  id="foundResult"
                  values={{
                    num: (
                      <Typography variant="inherit" component="span" color="primary">
                        {data?.content?.length || 0}
                      </Typography>
                    ),
                    total: (
                      <Typography variant="inherit" component="span" color="primary">
                        {data?.pagination?.totalElements || 0}
                      </Typography>
                    ),
                  }}
                />
              </Typography>
            </>
          }
          onDataLoading={isValidating}
        />
        <DentalList
          refresh={() => {
            revalidate();
          }}
          data={data?.content}
          total={data?.pagination?.totalElements || 0}
          hookPagination={hookPagination}
          loading={isValidating}
        />
      </Paper>
    </>
  );
};

export default NurseDentalListPage;
